<template>
  <section>
    <div class="container content-node image-bgcolor">
      <div class="col-12">
        <SetImage :set="set" :getApiHost="getApiHost" mode="full"/>
        <SetList :currentItem="set.currentItem" :items="set.items"/>
      </div>
    </div>
  </section>
</template>

<script>
  import SetImage from "./Set/Image";
  import SetList from "./Set/List";
  import Config from "@/vuex/Config";
  import SetData from "@/vuex/SetData";

  export default {
    name: 'ImageViewer',
    components: {
      SetImage,
      SetList,
    },
    data() {
      return {
        config: Config.getters.getConfig,
        getApiHost: Config.getters.getApiHost,
        set: SetData.getters.getSet
      }
    }
  }
</script>
